<template>
  <div>
    <div
      class="business-box"
      id="ss_box"
      :style="{
        height: height
      }"
    >
      <div
        class="business-line"
        v-for="(item, index) in projectList"
        :key="index"
      >
        <div class="business-con">
          <div class="business-lable">
            <div class="business-lable--box">
              <div class="lable-name">{{ item.name }}</div>
              <div class="lable-target" v-for="(targetItem, targetKey) in item.target" :key="targetKey">
                <span>{{ targetItem.name }}</span>{{ targetItem.value }}
              </div>
            </div>
            <!-- <span>{{ item.name }}</span> -->
          </div>
          <div class="business-item">
            <div
              class="coocaa_btn"
              :class="data.projectDashboard ? 'coocaa_btn project-see' : 'coocaa_btn'"
              v-for="(data, key) in item.data"
              :key="`${index}-${key}`"
              :downTarget="'#project_' + (index + 1)"
              :upTarget="getUpTarget(`${index}_${key}`)"
              :id="`project_${index}_${key}`"
              :dashboardId="data.dashboardId"
              :status="data.projectDashboard"
              rel="ss_project"
              @click="seeProject(data)"
            >
              <div
                :style="`width: ${data.width}%;margin-left:${data.left}%`"
                :class="`project-item project-item--${projectItem[data.projectType] || 'verification'}`"
              >
                <slot :data="data">
                  <div class="line">
                    <span class="lable">项目名称：</span>
                    <span class="value">{{ data.name }}</span>
                    <span class="tags"><i class="icon"></i>{{ data.projectCurrent }}</span>
                  </div>
                  <div class="line">
                    <span class="lable">目标：</span>
                    <span class="value">{{ data.projectValue }}</span>
                  </div>
                  <div class="line">
                    <span class="lable">成果：</span>
                    <span class="value">{{ data.manualWork }}</span>
                  </div>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pic-yAxis">
      <div class="pic-yAxis--box">
        <span v-for="(time, index) in timeData.timerShaft" :key="index" :style="`width:${time.ratio}%`">{{ time.time }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/mixins/common.js'
const currentTime = Date.parse(new Date())
// import common from '@/mixins/common.js'
export default {
  mixins: [common],
  components: {},
  props: {
    project: {
      type: Array,
      default: () => {
        return []
      }
    },
    height: {
      type: String,
      default: ''
    }
  },
  watch: {
    project: {
      handler (newValue, oldValue) {
        this.forProjectLIst()
      },
      deep: true
    }
  },
  data () {
    return {
      projectItem: {
        1: 'verification',
        2: 'dev',
        3: 'success',
        4: 'fail'
      },
      timeData: {},
      projectList: []
    }
  },
  computed: {
    isAndroid () {
      return this.$store.state.app.isAndroid
    }
  },
  methods: {
    seeProject (item) {
      if (this.keyCode) {
        this.keyCode = 0
      } else {
        if (item.projectDashboard) {
          this.$store.dispatch('toggleRoute', {
            name: this.$route.name,
            query: this.$route.query
          })
          localStorage.setItem('returnPage', location.pathname + location.search)
          const id = item.dashboardId
          if (id) {
            window.location = `/kanban-config-view?id=${id}`
          } else {
            window.location = `/ssp-project?id=20`
          }
        }
      }
    },
    getUpTarget (index) {
      if (index === '0_0') {
        return '#' + this.$route.name
      }
    },
    getTimerShaft () {
      const timestamp = (new Date()).valueOf()
      const startTime = timestamp - (86400000 * 45)
      const endTime = timestamp + (86400000 * 45)
      const timerShaft = []
      const totalDay = (endTime - startTime) / 86400000
      const dayRatio = 100 / totalDay
      const weekRatio = dayRatio * 7
      const startTimeWeek = new Date(startTime).getDay()
      let start
      if (startTimeWeek === 1) {
        start = startTime + (86400000 * 7)
        timerShaft.push({
          ratio: weekRatio,
          time: this.$cUtils.format.formatDate(new Date(startTime), 'MM-dd')
        })
      } else {
        start = startTime + (86400000 * (startTimeWeek ? 8 - startTimeWeek : 1))
        timerShaft.push({
          ratio: startTimeWeek ? dayRatio * (7 - startTimeWeek) : dayRatio
        })
      }
      const mistiming = parseInt(((endTime - start) / 86400000) / 7) + 1
      for (var i = 1; i < mistiming; i++) {
        const curTime = startTime + (86400000 * i * 7)
        timerShaft.push({
          ratio: weekRatio,
          time: this.$cUtils.format.formatDate(new Date(curTime), 'MM-dd')
        })
      }
      const startTimeArr = this.$cUtils.format.formatDate(new Date(startTime), 'yyyy-MM-dd').split('-')
      const curTimeArr = this.$cUtils.format.formatDate(new Date(), 'yyyy-MM-dd').split('-')
      const endTimeArr = this.$cUtils.format.formatDate(new Date(endTime), 'yyyy-MM-dd').split('-')
      const timeMap = {
        up: {
          year: startTimeArr[0],
          month: startTimeArr[1],
          day: startTimeArr[2]
        },
        cur: {
          year: curTimeArr[0],
          month: curTimeArr[1],
          day: curTimeArr[2],
          onDay: curTimeArr[2]
        },
        down: {
          year: endTimeArr[0],
          month: endTimeArr[1],
          day: endTimeArr[2]
        }
      }
      this.timeData = {
        timerShaft,
        totalDay,
        data: timeMap,
        curPosition: 15
      }
    },
    getTimestamp (date) {
      return Date.parse(new Date(date))
    },
    forProjectLIst () {
      this.projectList = this.project.map(list => {
        return {
          name: list.name,
          target: list.target,
          data: list.data ? list.data.map(item => {
            let itemData = {
              day: 60,
              width: 100,
              left: 0
            }
            if (item.projectEnd && item.projectStart) {
              const day = parseInt(((this.getTimestamp(item.projectEnd) - this.getTimestamp(item.projectStart)) / 86400) / 1000)
              const timeData = this.timeData
              const upData = timeData.data.up
              // const downData = timeDayta.data.down
              const start = ((this.getTimestamp(item.projectStart) - this.getTimestamp(`${upData.year}/${upData.month}/01 00:00:00`)) / 1000) / 86400
              const end = ((this.getTimestamp(item.projectEnd) - this.getTimestamp(`${upData.year}/${upData.month}/01 00:00:00`)) / 1000) / 86400
              const startPosition = start ? start > 0 ? parseFloat((start / timeData.totalDay).toFixed(2)) * 100 : 0 : start
              const endPosition = end ? end > 0 ? parseFloat((end / timeData.totalDay).toFixed(2)) * 100 : 100 : end
              itemData = {
                day: day,
                width: parseFloat((endPosition - startPosition).toFixed(2)),
                left: startPosition
              }
            }
            return Object.assign(item, itemData)
          }).reverse() : null
        }
      })
      // this.$nextTick(() => {
      //   this.$parent.bindKey(this.$route.name)
      // })
    }
  },
  created () {
    this.getTimerShaft()
    // this.forProjectLIst()
  }
}
</script>

<style lang="stylus" scoped>
@import '../stylus/Project-list.styl'
</style>
